<form action="" [formGroup]="eventForm">
  <h5 class="sub-title mb-3">
    {{ datas.title }} Event
    <button
      class="Approved-btn"
      *ngIf="statusValue == 0"
      (click)="ApprovedBtn(eventForm)"
    >
      Approve
    </button>
    <button
      class="reject-btn"
      *ngIf="statusValue == 0"
      (click)="RejectBtn(eventForm)"
    >
      Reject
    </button>
  </h5>
  <div class="row">
    <div class="col-lg-9 col-md-9 col-sm-12 col-12">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event Name <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Event Name"
                formControlName="eventName"
                [ngClass]="{
                  'is-invalid': add.eventName.touched && add.eventName.errors
                }"
              />
              <mat-error *ngIf="add.eventName.touched && add.eventName.errors">
                <span *ngIf="add.eventName.errors.required"
                  >Event Name is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event Location <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Event Location"
                formControlName="eventLocation"
                [ngClass]="{
                  'is-invalid':
                    add.eventLocation.touched && add.eventLocation.errors
                }"
              />
              <mat-error
                *ngIf="add.eventLocation.touched && add.eventLocation.errors"
              >
                <span *ngIf="add.eventLocation.errors.required"
                  >Event Location is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-8 col-md-12 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event Registration Link <span class="text-danger"></span
              ></mat-label>
              <input
                matInput
                placeholder="Enter Registration Link"
                formControlName="eventRegLink"
                [ngClass]="{
                  'is-invalid':
                    add.eventRegLink.touched && add.eventRegLink.errors
                }"
              />
              <mat-error
                *ngIf="add.eventRegLink.touched && add.eventRegLink.errors"
              >
                <span *ngIf="add.eventRegLink.errors.required"
                  >Registration Link is required</span
                >
                <span *ngIf="add.eventRegLink.errors.url"
                  >Please enter proper url format</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Website Link <span class="text-danger"></span
              ></mat-label>
              <input
                matInput
                placeholder="Enter Website Link"
                formControlName="eventWebsiteLink"
                [ngClass]="{
                  'is-invalid':
                    add.eventWebsiteLink.touched && add.eventWebsiteLink.errors
                }"
              />
              <mat-error
                *ngIf="
                  add.eventWebsiteLink.touched && add.eventWebsiteLink.errors
                "
              >
                <span *ngIf="add.eventWebsiteLink.errors.required"
                  >Website Link is required</span
                >
                <span *ngIf="add.eventWebsiteLink.errors.url"
                  >Please enter proper url format</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event Apply Last Date <span class="text-danger"></span
              ></mat-label>
              <input
                matInput
                type="text"
                placeholder="Datepicker"
                bsDatepicker
                [minDate]="applyLastMin"
                [(ngModel)]="bsLastValue"
                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                formControlName="eventApplyLastDate"
                [ngClass]="{
                  'is-invalid':
                    add.eventApplyLastDate.touched &&
                    add.eventApplyLastDate.errors
                }"
                (ngModelChange)="getFromDate($event)"
                readonly
              />
              <mat-error
                *ngIf="
                  add.eventApplyLastDate.touched &&
                  add.eventApplyLastDate.errors
                "
              >
                <span *ngIf="add.eventApplyLastDate.errors.required"
                  >Last Date is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-row">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event From Date <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                type="text"
                placeholder="Datepicker"
                bsDatepicker
                [minDate]="fromDateMin"
                [(ngModel)]="bsFromValue"
                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                formControlName="eventFromDate"
                (ngModelChange)="getFromDate($event)"
                [ngClass]="{
                  'is-invalid':
                    eventForm.get('eventFromDate').touched &&
                    eventForm.get('eventFromDate').errors
                }"
                readonly
              />
              <mat-error
                *ngIf="eventForm.get('eventFromDate').hasError('required')"
                >From Date is required</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event To Date <span class="text-danger"></span
              ></mat-label>
              <input
                matInput
                type="text"
                placeholder="Datepicker"
                bsDatepicker
                [minDate]="lastDateMin"
                [(ngModel)]="bsToValue"
                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                formControlName="eventToDate"
                (ngModelChange)="getToDate($event)"
                [ngClass]="{
                  'is-invalid':
                    add.eventToDate.touched && add.eventToDate.errors
                }"
                readonly
              />
              <mat-error
                *ngIf="add.eventToDate.touched && add.eventToDate.errors"
              >
                <span *ngIf="add.eventToDate.errors.required"
                  >To Date is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event From Time <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                [ngxTimepicker]="toggleTimepicker1"
                [disableClick]="true"
                readonly
                placeholder="Enter From Time"
                formControlName="eventFromTime"
                [ngClass]="{
                  'is-invalid':
                    eventForm.get('eventFromTime').touched &&
                    eventForm.get('eventFromTime').errors
                }"
              />
              <ngx-material-timepicker-toggle
                [for]="toggleTimepicker1"
                matSuffix
              >
              </ngx-material-timepicker-toggle>
              <ngx-material-timepicker
                #toggleTimepicker1
              ></ngx-material-timepicker>
              <mat-error
                *ngIf="eventForm.get('eventFromTime').hasError('required')"
                >From Time is required</mat-error
              >
              <mat-error
                *ngIf="eventForm.get('eventFromTime').hasError('pastTime')"
                >Selected time cannot be in the past</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Event To Time <span class="text-danger"></span
              ></mat-label>
              <input
                matInput
                [ngxTimepicker]="toggleTimepicker2"
                [disableClick]="true"
                readonly
                placeholder="Enter To Time"
                formControlName="eventToTime"
                [ngClass]="{
                  'is-invalid':
                    add.eventToTime.touched && add.eventToTime.errors
                }"
              />
              <ngx-material-timepicker-toggle
                [for]="toggleTimepicker2"
                matSuffix
              >
              </ngx-material-timepicker-toggle>
              <ngx-material-timepicker
                #toggleTimepicker2
              ></ngx-material-timepicker>
              <mat-error
                *ngIf="add.eventToTime.touched && add.eventToTime.errors"
              >
                <span *ngIf="add.eventToTime.errors.required"
                  >To Time is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
      <div class="p-relative">
        <p class="logo-span">
          Event Banner Image <span class="text-danger">*</span>
        </p>
        <div class="text-center">
          <div class="circle">
            <img class="profile-pic" [src]="image_url" />
          </div>
          <div>
            <label for="files" class="p-image">Upload Banner</label>
            <input
              class="file-upload"
              (change)="onSelectImage($event)"
              id="files"
              type="file"
              accept="image/*"
            />
          </div>
        </div>
        <p>
          <span class="noti-span"
            >(Supported Format: png,jpg,jpeg) <br />(Suggested Image Dimensions:
            700 x 600)<br />(max file size: 10mb)</span
          >
        </p>
        <p *ngIf="logoCheck == true" class="text-danger">
          Banner Image is required
        </p>
      </div>
      <div class="form-rows mt-3">
        <mat-label
          >Event Registration QR Code Image <span class="text-danger"></span
        ></mat-label>
        <label
          *ngIf="docName != '✔ Uploaded'"
          for="input-file-id"
          class="md-button md-raised md-primary"
        >
          Upload QR code
          <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
          <span class="ml-3">{{ docName }}</span>
          <input
            class="d-none"
            id="input-file-id"
            multiple
            type="file"
            (change)="fileUpload($event)"
            accept="image/*"
          />
        </label>
        <label
          *ngIf="docName == '✔ Uploaded'"
          for="input-file-id"
          class="md-button md-raised md-accent"
        >
          Update File
          <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
          <span class="ml-3">{{ docName }}</span>
          <input
            class="d-none"
            id="input-file-id"
            multiple
            type="file"
            (change)="fileUpload($event)"
            accept="image/*"
          />
        </label>
        <p>
          <span class="noti-span"
            >(Supported Format: png,jpg,jpeg)
            <span class="delete-span" *ngIf="docName"
              ><i
                class="fas fa-trash delete-i"
                (click)="deleteImage()"
                aria-hidden="true"
              ></i
            ></span>
            <br />(max file size: 10mb)</span
          >
        </p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-9 col-md-9 col-sm-12 col-12">
      <div class="form-rows">
        <mat-label
          >Event Description <span class="text-danger"></span
        ></mat-label>
        <ckeditor
          [disabled]="statusValue === 2"
          [editor]="Editor"
          formControlName="eventDescription"
          [ngClass]="{
            'is-invalid':
              add.eventDescription.touched && add.eventDescription.errors
          }"
          (ready)="onReady($event)"
          (change)="onChange($event)"
        >
        </ckeditor>
        <mat-error
          *ngIf="add.eventDescription.touched && add.eventDescription.errors"
        >
          <span *ngIf="add.eventDescription.errors.required"
            >Event Description is required</span
          >
          <p *ngIf="img == 'show'" class="text-danger">Format is invalid</p>
        </mat-error>
      </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
      <div class="text-center mt-5">
        <button
          class="update-btn"
          color="primary"
          (click)="saveEvent()"
          *ngIf="statusValue != 2"
        >
          {{ savelbl }}
        </button>
        <button class="mr-2" class="cancel-btn" (click)="cancelEvent()">
          Cancel</button
        ><br />
      </div>
    </div>
  </div>
</form>
